<template>
    <toolbar-option>
        <template slot="primary">
            <toggle
                :value="checked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const HIDE_CAROUSEL_CONTROLS = 'hide-carousel-controls';

export default {
    name: 'carousel-controls-visibility',
    mixins: [baseOption],

    data() {
        return {
            checked: true,
            displayName: 'Control Visibility',

            messages: {
                checked: 'Show',
                unchecked: 'Hide',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            if (isChecked) {
                this.selectedElements[0].removeElementData(HIDE_CAROUSEL_CONTROLS);
            } else {
                this.selectedElements[0].setElementData(HIDE_CAROUSEL_CONTROLS, 'true');
            }

            this.checked = isChecked;
            this.onOptionChange(isChecked);
        },

        onSelectedElement() {
            this.checked = !this.selectedElements[0].hasElementData(HIDE_CAROUSEL_CONTROLS);
        },
    },
};
</script>
